import {
  DELETE_SURVEY,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/surveys/id/delete'
import type { DeleteSurveyParams } from 'app/common/types/surveys'
import { api } from 'app/api'
import { useCallback, useState } from 'react'
import useCallbackRef from 'app/common/hooks/useCallbackRef'

const apiMessage = (fallback: string) => (error: Error & { response?: { data?: { message?: string } } }) => (
  error.response?.data?.message || fallback
)

type Op = {
  surveyId: DeleteSurveyParams['surveyId']
  onSuccess?: () => void
}

export const useDeleteSurvey = ({ surveyId, onSuccess }: Op) => {
  const [pending, setPending] = useState<boolean>(false)
  const onSuccessRef = useCallbackRef(onSuccess)

  const submit = useCallback(async () => {
    setPending(true)
    const res = await api.request(DELETE_SURVEY, {
      error: apiMessage('Не удалось удалить опрос'),
      params: { surveyId },
      convertions: {
        convertParams,
        convertResult,
      },
    })

    if (res) {
      setPending(false)
      onSuccessRef.current?.()
      return true
    }

    setPending(false)
    return false
  }, [onSuccessRef, surveyId])

  return {
    pending,
    submit,
  }
}
